import React from "react";
import { Box, Typography } from "@mui/material";
import SearchField from "../search/SearchField.tsx";
import ExampleItems from "../example/ExampleItems.tsx";
import { Trans } from "@lingui/react/macro";

interface CircleComponentProps {
  children?: React.ReactNode;
}

const CircleContent: React.FC<CircleComponentProps> = () => {
  return (
    <Box
      sx={{
        height: "100%", // fill parent (.interface__content)
        width: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        alignItems: "stretch", // let children take full width; we center inside children
      }}
    >
      {/* Top third */}
      <Box
        sx={{
          flex: { xs: 0.4, md: 0.45 },
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontSize: { lg: "4rem", md: "3.3rem", sm: "3rem", xs: "1.5rem" },
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          <Trans context="Greeting message stating the name of the service is Tally.">
            Hi, I'm Tally!
          </Trans>
        </Typography>
      </Box>

      {/* Middle third */}
      <Box
        sx={{
          flex: { xs: 0.2, md: 0.1 },
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: { xs: "90%", sm: "100%" },
          boxSizing: "border-box",
          margin: "0 auto",
        }}
      >
        <SearchField isCircleView={true} />
      </Box>

      {/* Bottom third */}
      <Box
        sx={{
          flex: { xs: 0.4, md: 0.45 },
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Inner wrapper to give horizontal breathing room while staying centered */}
        <Box
          sx={{
            width: "95%",
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <ExampleItems isCircleView={true} />
        </Box>
      </Box>
    </Box>
  );
};

export default CircleContent;
